module.exports = {"id":"221306","name":"Michael Barrios","rating":"73","photo":"./data/images/photos/3/221306.png","club":{"name":"FC Dallas","logo":"./data/images/clubs/FCDallas.png"},"positions":["MD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelBarrios0.json
// module id = 2978
// module chunks = 0